export const highchartChatDashboardStatsConfig = (data: any) => {
  let total = 0;
  let config: Highcharts.Options = {
    chart: {
      spacingLeft: 0,
      spacingRight: 0,
      spacingTop: 0,
      spacingBottom: 0,
      // width: 125,
      events: {
        load: function (event: Event) {
          total = 0;
          var chart: any = this,
            points = chart.series[0].points,
            len = points.length,
            i = 0;

          for (0; i < len; i++) total += points[i].y;

          chart.setSubtitle({
            text: data.toFixed(2) + '%',
          });
        },
        redraw: function (event: Event) {
          total = 0;
          var chart: any = this,
            points = chart.series[0].points,
            len = points.length,
            i = 0;

          for (0; i < len; i++) total += points[i].y;

          chart.setSubtitle({
            text: data.toFixed(2) + '%',
          });
        },
      },
    },
    title: {
      text: undefined,
      // align: 'top',
      verticalAlign: 'middle',
      y: 0,
      x: 0,
      style: {
        fontSize: '18px',
      },
    },
    subtitle: {
      //text: 'SMS',
      verticalAlign: 'middle',
      y: 20,
      x: 0,
      style: { fontWeight: 'normal', fontSize: '22px' },
    },
    series: [
      {
        type: 'pie',
        name: 'Percentage',
        innerSize: '80%',
        data: [data, 100 - data],
      },
    ],
  };
  return config;
};
